import React, { useEffect, useState } from "react";
import axios from "axios";
import BreadcrumbsHeader from "../breadcrumbs/BreadcrumbsHeader"
import "aos/dist/aos.css";
import AOS from "aos";

const InfluencerMarketing = () => {
  const [influencers, setInfluencers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    AOS.init({ duration: 1000 });

    // Fetch influencer data from CodeIgniter API
    axios
      .get("https://www.isolsgroup.com/new/api/ApiInfluencer", {
        headers: { "X-API-KEY": "ISOLS" },
      })
      .then((res) => {
        console.log("Influencer API:", res.data);
        if (res.data && Array.isArray(res.data.data)) {
          setInfluencers(res.data.data);
        } else {
          setInfluencers([]);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching influencers:", err);
        setLoading(false);
      });
  }, []);

  return (
    <div className="page-container">
      {/* Breadcrumbs Header */}
      <BreadcrumbsHeader
        title="Our Influencer Network"
        backgroundImage="/images/breadcrumbs/influencer.jpg"
      />

      {/* Influencer Network Section */}
      <section className="section-works">
        <div className="container">
          <h2 className="termm">
            Join Our Influencer Network
          </h2>

          <div className="row">
            {loading ? (
              <p className="text-center">Loading influencers...</p>
            ) : influencers.length > 0 ? (
              influencers.map((inf, index) => (
                <div
                  className="col-lg-3 col-md-3 col-sm-3"
                  key={index}
                  data-aos="fade-up"
                >
                  <div className="influence">
                    <div className="influ text-center">
                      <a
                        href={inf.instagram}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={`https://www.isolsgroup.com/uploaded-images/gallery/${inf.image}`}
                          alt={inf.name}
                        />
                      </a>
                    </div>
                    <div className="influence1">
                      <p>
                        <strong>Name :</strong> {inf.name}
                      </p>
                      <p>
                        <strong>Category :</strong> {inf.category}
                      </p>
                      <p>
                        <strong>Industry :</strong> {inf.industry}
                      </p>
                      <p>
                        <strong>Followers :</strong> {inf.follower}
                      </p>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-center">No influencers available.</p>
            )}
          </div>

          {/* Bottom Text */}
          <div className="col-xs-12 col-sm-12 col-md-12">
            <div className="influ text-center" style={{ marginTop: "30px" }}>
              <h4>
                <strong>Rocking Influencer Network of ISOLS is Growing...</strong>
              </h4>
            </div>
          </div>
        </div>
      </section>

      
    </div>
  );
};

export default InfluencerMarketing;
